module.exports = __webpack_public_path__ + "img/368874-31-1.9e044909.png";